import {
  type NavigationFailure,
  type RouteLocationNamedRaw,
  type Router,
  type RouteRecordRaw,
} from "vue-router";

import { APP_ROUTES } from "@/Generated/Routes/paths";

import authRoutes from "./auth";
import chatRoutes from "./Chat";
import errorRoutes from "./errors";
import settingsRoutes from "./Settings";
import agentRoutes from "./agent";
import calendarsRoutes from "./calendars";
import patientsRoutes from "./patients";

import { buildBeforeEnterChain, initWSGuard } from "../guards";

export interface TcRouter extends Router {
  pushInternal: (to: RouteLocationNamedRaw) => Promise<void | NavigationFailure | undefined>;
}

export default [
  ...authRoutes,

  {
    ...APP_ROUTES.chat.connected.root,
    component: () => import("@/Views/chat/ConnectFromOtherLocation.vue"),
  },

  {
    component: () => import("@/Components/layout/MainLayout.vue"),
    beforeEnter: buildBeforeEnterChain(initWSGuard),
    children: [
      {
        ...APP_ROUTES.root,
        components: { main: () => import("@/Views/Home/index.vue") },
        meta: { sidebar: false },
      },
      {
        ...APP_ROUTES.home.root,
        components: { main: () => import("@/Views/Home/index.vue") },
        meta: { sidebar: false },
      },
      {
        ...APP_ROUTES.activity.root,
        components: {
          sidebar: () => import("@/Views/activityCenter/index.vue"),
          main: () => import("@/Views/MainLanding.vue"),
        },
        meta: { sidebar: true, drawer: false },
      },
      ...settingsRoutes,
      ...patientsRoutes,
      ...chatRoutes,
      ...agentRoutes,
      ...calendarsRoutes,
    ],
  },

  {
    ...APP_ROUTES.onboarding.root,
    component: () => import("@/Views/onboarding/index.vue"),
    meta: {
      isPublic: true,
      canonical: APP_ROUTES.onboarding.root.path,
    },
  },

  {
    ...APP_ROUTES.sso.root,
    component: () => import("@/Views/SSO.vue"),
    meta: {
      isPublic: true,
    },
  },

  {
    ...APP_ROUTES.refreshStripe.root,
    component: () => import("@/Views/RefreshStripe.vue"),
  },

  ...errorRoutes, // Need to be the last
] as RouteRecordRaw[];
